import { Component, OnDestroy, OnInit } from '@angular/core';
import { TabModel } from '@app/features/app-content/models/app-tabs.model';
import { UpdateAppConfig } from '@app/features/app-content/states/app-configuration.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription, combineLatest, filter, map, shareReplay } from 'rxjs';

@Component({
  selector: 'rk-page-design-editor',
  templateUrl: './page-design-editor.component.html',
  styleUrl: './page-design-editor.component.scss',
  standalone: false,
})
export class PageDesignEditorComponent implements OnInit, OnDestroy {
  @Select(AppConfigurationState.activePageIndex)
  activePageIndex$: Observable<number>;

  @Select(AppConfigurationState.currentAppConfigPageList)
  currentAppConfigPageList$: Observable<TabModel>;

  backgroundColor$: Observable<string>;
  headerTextColor$: Observable<string>;
  backgroundColorOptionAvailable$: Observable<boolean>;
  forceBackgroundColor: boolean;

  private readonly subscriptions = new Subscription();
  pageIndex: number;

  constructor(private readonly store: Store) { }

  ngOnInit(): void {
    const currentPage$ = combineLatest([
      this.currentAppConfigPageList$,
      this.activePageIndex$,
    ]).pipe(
      filter(([pageList, pageIndex]) => !!pageList && !!pageIndex),
      map(([pageList, pageIndex]) => pageList[pageIndex]),
      shareReplay(1)
    );

    this.backgroundColor$ = currentPage$.pipe(
      map(page =>
        page?.type === 'podcasts' && page?.backgroundColor ? page.backgroundColor : '',
      ),
    );

    this.backgroundColorOptionAvailable$ = currentPage$.pipe(
      map(page => page?.type === 'podcasts'),
    );

    this.subscriptions.add(
      currentPage$.subscribe(
        page => (this.forceBackgroundColor = page.forceBackgroundColor),
      ),
    );

    this.headerTextColor$ = combineLatest([
      this.currentAppConfigPageList$,
      this.activePageIndex$,
    ]).pipe(
      filter(([pageList, pageIndex]) => !!pageList && !!pageIndex),
      map(([pageList, pageIndex]) => pageList[pageIndex].headerTextColor),
    );

    this.subscriptions.add(
      this.activePageIndex$
        .pipe(filter(index => !!index))
        .subscribe(id => (this.pageIndex = Number(id))),
    );
  }

  onForceBackgroundColorChange(show: boolean) {
    this.store.dispatch(
      new UpdateAppConfig(
        ['onglets', this.pageIndex.toString(), 'forceBackgroundColor'],
        show,
      ),
    );
  }

  onBackgroundColorChange(color: string) {
    this.store.dispatch(
      new UpdateAppConfig(['onglets', this.pageIndex.toString(), 'backgroundColor'], color),
    );
  }

  onHeaderTextColorChange(color: string) {
    this.store.dispatch(
      new UpdateAppConfig(
        ['onglets', this.pageIndex.toString(), 'headerTextColor'],
        color,
      ),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
